import moment from "moment";
import { SubAppCode } from "./engine/consts";

export const focusInputByName = (name: string) => {
  (
    document.querySelector(`input[name='${name}']`) as HTMLInputElement | null
  )?.focus();
};

export const filterObjectOld = <T>(obj: T, keys: Array<keyof T>) => {
  const result: Pick<T, (typeof keys)[number]> = {} as any;

  keys.forEach((key) => {
    if (obj[key] === undefined) {
      return;
    }
    result[key] = obj[key];
  });

  return result;
};

const isValidValue = (val: any): boolean => {
  if (val == null) return false;
  if (typeof val === "string" && val.trim() === "") return false;
  if (typeof val === "object") {
    if (!("value" in val) || val.value === "") return false;
  }
  return true;
};

export const filterObject = (
  obj: any,
  keys: any,
  expertModeType: any = null
): any => {
  const result: any = {};

  const keyMapping: Record<string, string> = {
    applicatif: "application",
    sous_application: "subApplication",
    t_eau_chaude: "TECS",
    temperature_primaire: "Tp",
    pertes_thermiques_bouclage: "Pboucle",
    largeur_de_passage: "largeur_porte",
    hauteur_sous_plafond: "hauteur_porte",
  };

  const keysWithObjectValues: Record<string, string> = {
    circPrim: "circulateur_primaire",
    Ouverture: "ouverture",
    circSec: "circulateur_secondaire",
    // CuveInox: "CuveInox",
    Jaquette: "jaquette",
    nbBallon: "nbBallon",
    circ: "circ",
    // extensible: "extensible",
  };

  Object.keys(keys).forEach((key) => {
    const value = keys[key];

    // Case: nested object → recurse
    if (typeof value === "object" && value !== null) {
      result[key] = filterObject(obj, value, expertModeType);
      return;
    }

    // Case: object value from keysWithObjectValues
    if (key in keysWithObjectValues) {
      const val = obj[key];
      if (!isValidValue(val)) return;
      result[keysWithObjectValues[key]] =
        typeof val === "object" ? val.value : val;
      return;
    }

    // Case: key is in keyMapping
    if (key in keyMapping && obj[keyMapping[key]] !== undefined) {
      const mappedValue = obj[keyMapping[key]];
      result[key] =
        mappedValue === "etablissements_scolaires"
          ? "etablissement_scolaires"
          : mappedValue;
      return;
    }

    // Fallback case
    result[key] = obj[key] || value;
  });

  if (
    result.sous_application === SubAppCode.LOGEMENTSPRIVES ||
    result.sous_application === SubAppCode.LOGEMENTSSOCIAUX ||
    result.sous_application === SubAppCode.RESIDENCESSENIORS
  ) {
    if (!expertModeType || expertModeType === "appartement") {
      delete result.consoBatiment;
    } else {
      Object.keys(result).forEach((key) => {
        if (key.startsWith("conso") && key !== "consoBatiment") {
          delete result[key];
        }
      });
    }
  }

  return result;
};

export function formatMinutes(minutes: number) {
  const hr: number = Math.floor(minutes / 60),
    min: number = Math.floor(minutes % 60);
  return moment(`${hr}:${min}`, "hhmm").format("HH:mm");
}

export function formatDateTime(isoString?: string | undefined | null) {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const roundTo1Decimals = (value?: number) => {
  return value && Math.round((value + Number.EPSILON) * 10) / 10;
};

// Shallow, unordered array equality
export function areArraysEqual(a: any[], b: any[]): boolean {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((val, idx) => val === sortedB[idx]);
}
